// Form validation for Quote form
import { useIntl, getTranslatedText } from '@nile/components';

export default {
  description: {
    presence: {
      allowEmpty: false,
      message: () => {
        const intl = useIntl();
        return `^${getTranslatedText(intl, 'validation.description.empty')}`;
      }
    }
  },
  expiryDate: {
    presence: {
      allowEmpty: false,
      message: () => {
        const intl = useIntl();
        return `^${getTranslatedText(intl, 'validation.expiryDate.empty')}`;
      }
    }
  }
};
